import { t as e } from "../../../v99990101-BAnGoto_.js";
export { e as dashboardv99990101Client };
